import { render, staticRenderFns } from "./EditCorrespondanceDialog.vue?vue&type=template&id=a6f70da0&"
import script from "./EditCorrespondanceDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCorrespondanceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports